import { useEffect } from 'react';
import { useFindByQuery } from '../../graphql';
import { useCurrentWorkspace } from '../../auth';

const FIND_WORKSPACE_LABELS = `
  query FindWorkspaceLabels($filter: LabelFilter) {
    findLabels(filter: $filter) {
      items {
        id
        name
      }
    }
  }
`;

export const useWorkspaceLabels = (workspaceId?: string, storageOnly?: boolean) => {
  const currentWorkspace = useCurrentWorkspace(storageOnly);
  const targetWorkspaceId = workspaceId || currentWorkspace?.id;

  const { data, isLoading, refetch } = useFindByQuery({
    modelName: 'label',
    query: FIND_WORKSPACE_LABELS,
    variables: targetWorkspaceId ? {
      filter: {
        workspace: { eq: targetWorkspaceId }
      }
    } : undefined,
    options: {
      enabled: !!targetWorkspaceId, // Only fetch when workspace ID is available
    },
  });

  // Auto-refetch when workspaceId becomes available
  useEffect(() => {
    if (targetWorkspaceId) {
      refetch();
    }
  }, [targetWorkspaceId, refetch]);

  return {
    labels: data?.items || [],
    isLoading,
    refetch,
  };
};
